import * as React from 'react'

import { StockDetailTimeframeBar, useChartLayoutGlobalModel } from '../../../app/charts-lib'
import { NotificationWrapper } from '../../../main/components/notification'
import { decodeQueryString } from '../../queryString'
import { ChartTypesSelect } from '../chart-type-select'
import Draw from '../draw'
import { Fullscreen } from '../fullscreen'
import Settings from '../settings'
import { MenuLinks } from './menu-links'

interface Props {
  index: number
  isChartTAS: boolean
  isScreener: boolean
  isInteractiveChart: boolean
  isStockDetailUpdating: boolean
}

export function QuoteMenu({ index, isChartTAS, isScreener, isInteractiveChart, isStockDetailUpdating }: Props) {
  const { chartLayoutModel } = useChartLayoutGlobalModel()

  const { ty, i } = decodeQueryString()
  const isPremium = FinvizSettings.hasUserPremium

  if (i && !chartLayoutModel?.idea) {
    return null
  }

  return (
    <div className="my-3 flex items-center justify-center">
      <div className="emulated-flex-gap relative flex max-w-full flex-wrap items-center justify-center">
        <MenuLinks index={index} isPremium={isPremium} isScreener={isScreener} />
        <div className="flex max-w-full flex-shrink items-center">
          {ty !== 'p' && (
            <>
              <div className="fullview-links mr-0.5 ml-auto items-center">
                <ChartTypesSelect isPremium={isPremium} />
              </div>
              <div className="overflow-hidden">
                <NotificationWrapper>
                  <StockDetailTimeframeBar
                    isPremium={isPremium}
                    isDateRangeAvailable={isInteractiveChart}
                    isLoadingOverride={isInteractiveChart ? undefined : isStockDetailUpdating}
                  />
                </NotificationWrapper>
              </div>
            </>
          )}
          {ty !== 'p' && isChartTAS && (
            <div className="mr-auto ml-0.5 flex">
              <Draw isPremium={isPremium} />
              <Fullscreen isPremium={isPremium} />
              <Settings isPremium={isPremium} />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
